import { Injectable } from '@angular/core';

import { getDateFormat, getDefinedFormat } from 'libraries/changeFormat';
import { IDateParserOptions } from './IDateParserOptions';
import { IDateParser } from './IDateParser';
import { LanguageService } from "../language/language.service";

interface IFormat {
    format: RegExp[];
    equ(value: string): Date;
}

@Injectable()
export class LegacyDateParserService implements IDateParser{
    private format: string;
    private definedFormats: IFormat[];


    constructor(public readonly languageService: LanguageService){
        this.format = getDateFormat(this.languageService.getUserLanguage());
        this.definedFormats = getDefinedFormat(this.format);
    }

    public parse(text: string, options: IDateParserOptions = {}): Date{
        // validating and conversion of normal and common formats
        for (const formatList of this.definedFormats) {
            for (const format of formatList.format) {
                // check if the user input data is mathching any rules
                if (format.test(text.toString())) {
                    return formatList.equ(text);
                }
            }
        }

        return null;
    }
}